import { IUserAdCreditCollapseHistory } from "@/utilities/types/AdCredit";
import AdCreditRepository from "@/utilities/repositories/AdCredit";
import { useTableServer } from "@/hooks/useTableServer";
import ControlledTable from "@/components/controlled-table";
import { memo, useEffect, useMemo } from "react";
import { getColumns } from "./columns";

function AdCreditTransactions({
  userId,
  isReFetchHistory = false,
  handleRefreshHistory,
  categoryFilter,
  onRevertSuccess,
}: {
  userId?: string;
  isReFetchHistory?: boolean;
  handleRefreshHistory?: () => void;
  categoryFilter?: string;
  onRevertSuccess?: () => void;
}) {
  const {
    isLoading,
    tableData,
    currentPage,
    totalItems,
    handlePaginate,
    pageSize,
    handleChangePageSize,
    sortConfig,
    handleSort,
    updateFilter,
  } = useTableServer({
    server: {
      request: userId
        ? AdCreditRepository.getUserAdCreditCollapseHistoryByAdmin({ userId })
        : AdCreditRepository.getUserAdCreditCollapseHistory,
      key: "ad-credit-transaction",
    },
    searchBy: (searchTerm) => {
      const s = searchTerm || undefined;
      return {
        search: s,
      };
    },
  });

  const handleRevertSuccess = () => {
    handlePaginate(currentPage);
    handleRefreshHistory?.();
    onRevertSuccess?.();
  };

  const columns = useMemo(
    () => getColumns(sortConfig, handleSort, handleRevertSuccess),
    [sortConfig, handleSort, currentPage],
  );

  useEffect(() => {
    if (isReFetchHistory) {
      handlePaginate(1);
      handleRefreshHistory?.();
    }
  }, [handlePaginate, handleRefreshHistory, isReFetchHistory]);

  useEffect(() => {
    updateFilter("category", categoryFilter || undefined);
  }, [categoryFilter]);

  return (
    <ControlledTable<IUserAdCreditCollapseHistory>
      variant="modern"
      data={tableData}
      isLoading={isLoading}
      showLoadingText={true}
      // @ts-expect-error - The ControlledTable component expects a different column type
      columns={columns}
      paginatorOptions={{
        pageSize,
        setPageSize: handleChangePageSize,
        total: totalItems,
        current: currentPage,
        onChange: (page: number) => handlePaginate(page),
      }}
      className="rounded-md border border-muted text-sm shadow-sm [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:h-60 [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:justify-center [&_.rc-table-row:last-child_td.rc-table-cell]:border-b-0 [&_thead.rc-table-thead]:border-t-0"
      rowKey={"transactionID"}
    />
  );
}

export default memo(AdCreditTransactions);
